module.exports = __webpack_public_path__ + "img/service-1.d48b4fa4.svg";